import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { SearchFilterItem } from '../../../models/SearchFilterItem';
import { ClearFilterService } from '../../../services/clear-filter.service';

@Component({
  selector: 'pix-dropdown-rating-filter3',
  templateUrl: './dropdown-rating-filter3.component.html',
  styleUrls: ['./dropdown-rating-filter3.component.css']
})
export class DropdownRatingFilterComponent3 implements AfterViewInit {
  @Input() tab: string;
  @Input() title: string;
  @Input() param: string;
  @Input() iconHtml: string;
  @Input() isMultiple: boolean;
  @Input() facets: any;
  @Input() noFacets: boolean;
  @Input() items;
  @Output() onRangeChanged = new EventEmitter<SearchFilterItem>();
  @Output() onRemoveFilterItem = new EventEmitter<SearchFilterItem>();
  @Output() close = new EventEmitter<any>();
  @Input() disabled: boolean;

  @ViewChild('dropdownEl') dropdownEl: ElementRef;

  selected = {
    L: false,
    M: false,
    H: false,
    C: false
  };

  constructor(private clearFilterService: ClearFilterService) {
    this.clearFilterService.clearFilterConfirmed$.subscribe(filterItem => {
      if (filterItem.param === this.param) {
        this.selected[filterItem.values[0]] = false;
      }
    });
  }

  ngAfterViewInit(): void {}

  onSelect(rating, event: any) {
    if (!this.disabled) {
      const text = `${this.title}: ${
        rating === 'L'
          ? 'LOW'
          : rating === 'M'
          ? 'MEDIUM'
          : rating === 'H'
          ? 'HIGH'
          : 'CRITICAL'
      }`;
      const aggregate = !this.isMultiple;
      const filterItem = {
        event: event,
        tab: this.tab,
        aggregate: aggregate,
        iconHtml: this.iconHtml,
        param: this.param,
        text: text,
        values: [rating]
      };
      if (this.isMultiple) {
        this.selected[rating] = !this.selected[rating];
        if (this.selected[rating]) {
          this.onRangeChanged.emit(filterItem);
        } else {
          this.onRemoveFilterItem.emit(filterItem);
        }
      } else {
        // reset
        this.selected = {
          L: false,
          M: false,
          H: false,
          C: false
        };
        this.selected[rating] = true;
        this.onRangeChanged.emit(filterItem);
      }
    }
  }

  onSelect2(rating, event: any) {
    if (!this.disabled) {
      if (
        this.facets &&
        this.facets[this.param] &&
        this.facets[this.param][rating.value] > 0
      ) {
        let text = `${this.title}: ${rating.name}`;
        let aggregate = !this.isMultiple;
        let filterItem = {
          tab: this.tab,
          aggregate: aggregate,
          iconHtml: this.iconHtml,
          param: this.param,
          text: text,
          values: [rating.value],
          event: event
        };
        if (this.isMultiple) {
          rating.selected = !rating.selected;
          if (rating.selected) {
            this.onRangeChanged.emit(filterItem);
          } else {
            this.onRemoveFilterItem.emit(filterItem);
          }
        } else {
          // reset
          this.items.forEach(item => {
            item.selected = false;
          });
          rating.selected = true;
          this.onRangeChanged.emit(filterItem);
        }
      } else if (this.noFacets) {
        let text = `${this.title}: ${rating.name}`;
        let aggregate = !this.isMultiple;
        let filterItem = {
          tab: this.tab,
          aggregate: aggregate,
          iconHtml: this.iconHtml,
          param: this.param,
          text: text,
          values: [rating.value]
        };
        if (this.isMultiple) {
          rating.selected = !rating.selected;
          if (rating.selected) {
            this.onRangeChanged.emit(filterItem);
          } else {
            this.onRemoveFilterItem.emit(filterItem);
          }
        } else {
          // reset
          this.items.forEach(item => {
            item.selected = false;
          });
          rating.selected = true;
          this.onRangeChanged.emit(filterItem);
        }
      }
    }
  }

  closeClick(event) {
    this.close.emit(event);
  }
}
